/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetSubscriptionUsage200ResponseDevices
 */
export interface GetSubscriptionUsage200ResponseDevices {
    /**
     * 
     * @type {number}
     * @memberof GetSubscriptionUsage200ResponseDevices
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof GetSubscriptionUsage200ResponseDevices
     */
    max: number;
}

/**
 * Check if a given object implements the GetSubscriptionUsage200ResponseDevices interface.
 */
export function instanceOfGetSubscriptionUsage200ResponseDevices(value: object): value is GetSubscriptionUsage200ResponseDevices {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('max' in value) || value['max'] === undefined) return false;
    return true;
}

export function GetSubscriptionUsage200ResponseDevicesFromJSON(json: any): GetSubscriptionUsage200ResponseDevices {
    return GetSubscriptionUsage200ResponseDevicesFromJSONTyped(json, false);
}

export function GetSubscriptionUsage200ResponseDevicesFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSubscriptionUsage200ResponseDevices {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'max': json['max'],
    };
}

export function GetSubscriptionUsage200ResponseDevicesToJSON(json: any): GetSubscriptionUsage200ResponseDevices {
    return GetSubscriptionUsage200ResponseDevicesToJSONTyped(json, false);
}

export function GetSubscriptionUsage200ResponseDevicesToJSONTyped(value?: GetSubscriptionUsage200ResponseDevices | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'max': value['max'],
    };
}

